<template>
	<div >
		<div class="container">
			<div class="row justify-content-between visible-on slb-cnt" style="min-height: 90vh;">
				<div class="col-md-6 col-xl-5 cnt" style="text-align: left;">
					<h3 class="zy-title">{{data.title}}</h3>
					<p class="zy-desc">{{data.desc}}</p>
					<b-button variant="danger" class="join" @click="handleLogin">立即加入</b-button>
				</div>
				<div class="col-md-6 col-xl-6 ">
					<img draggable="false" :src="data.image" alt="" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			data: Object
		},
		data() {
			return {
				slide: 0,
				sliding: null
			}
		},
		methods: {
			onSlideStart(slide) {
				this.sliding = true
			},
			onSlideEnd(slide) {
				this.sliding = false
			},
			handleLogin() {
				this.$router.push("/login");
			}
		}
	}
</script>


<style scoped lang="scss">
	
	.slb-cnt {
		display: flex;
		align-items: center;
		padding-top: 40px;
		padding-top: 40px;
	}

	.join {
		margin-top: 20px;
		
		font-size: calc(0.7em + 0.5vw);
		background: linear-gradient(312deg, #FF2020 0%, #FF4356 100%) !important;
	}
	
	.cnt {
		// padding: 40px;
	}
</style>
